var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-linkedin 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.2405 3.32227H5.76055C3.99415 3.32227 2.56055 4.80067 2.56055 6.62227V27.7423C2.56055 29.5639 3.99415 31.0423 5.76055 31.0423H26.2405C28.0069 31.0423 29.4405 29.5639 29.4405 27.7423V6.62227C29.4405 4.80067 28.0069 3.32227 26.2405 3.32227ZM10.8805 13.8823V26.4223H7.04055V13.8823H10.8805ZM7.04055 10.2325C7.04055 9.30847 7.80855 8.60227 8.96055 8.60227C10.1125 8.60227 10.8357 9.30847 10.8805 10.2325C10.8805 11.1565 10.1637 11.9023 8.96055 11.9023C7.80855 11.9023 7.04055 11.1565 7.04055 10.2325ZM24.9605 26.4223H21.1205C21.1205 26.4223 21.1205 20.3107 21.1205 19.8223C21.1205 18.5023 20.4805 17.1823 18.8805 17.1559H18.8293C17.2805 17.1559 16.6405 18.5155 16.6405 19.8223C16.6405 20.4229 16.6405 26.4223 16.6405 26.4223H12.8005V13.8823H16.6405V15.5719C16.6405 15.5719 17.8757 13.8823 20.3589 13.8823C22.8997 13.8823 24.9605 15.6841 24.9605 19.3339V26.4223Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.fe077cd392b3cc0ff3a2130d808df3e8.svg";
export { ForwardRef as ReactComponent };